import React from 'react';

/**
 * Icono de convención para POSConvention
 *
 * Círculo SVG de 16x16px con colores diferentes para Light y Dark mode.
 * Basado en especificaciones de Figma:
 * - Light mode: node-id 4418-40139
 * - Dark mode: node-id 4418-40349
 *
 * Usa dos círculos superpuestos con clases CSS para alternar entre modos.
 *
 * @param lightColor - Color hexadecimal para Light mode
 * @param darkColor - Color hexadecimal para Dark mode
 * @param className - Clases CSS adicionales (opcional)
 */
export const ConventionIcon: React.FC<{
  lightColor: string;
  darkColor: string;
  className?: string;
}> = ({ lightColor, darkColor, className = '' }) => (
  <svg
    className={`w-4 h-4 shrink-0 ${className}`.trim()}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-hidden="true"
  >
    {/* Círculo para Light mode - visible por defecto, oculto en dark */}
    <circle
      cx="8"
      cy="8"
      r="8"
      fill={lightColor}
      className="dark:hidden"
    />
    {/* Círculo para Dark mode - oculto por defecto, visible en dark */}
    <circle
      cx="8"
      cy="8"
      r="8"
      fill={darkColor}
      className="hidden dark:block"
    />
  </svg>
);
